import React from 'react';
import { ErrorLabel } from '../Styles';

const ErrorMessage = ({ message, position }) => {
  return <ErrorLabel position={position}>{message}</ErrorLabel>;
};

export default ErrorMessage;
